import { AddressFields } from 'api/address/types/AddressFields';

export const REQUIRED_ADDRESS_FIELDS = [
  'country',
  'city',
  'addressLine1',
  'zipCode',
  'firstName',
  'lastName',
] as const;

export const isAddressValid = (address: AddressFields | null): boolean => {
  if (!address) return false;
  return REQUIRED_ADDRESS_FIELDS.every((field) => address[field]);
};

export const getValidAddress = (
  addresses: AddressFields[] | null | undefined
): AddressFields | null => {
  if (!addresses?.length) return null;

  const validDefaultAddress = addresses.find(
    (address) => address?.isDefault && isAddressValid(address)
  );
  if (validDefaultAddress) return validDefaultAddress;

  const validAddress = addresses.find((address) => isAddressValid(address));
  return validAddress || null;
};

export const hasValidAddresses = (
  addresses: AddressFields[] | null | undefined
): boolean => {
  if (!addresses?.length) return false;
  return addresses.some((address) => isAddressValid(address));
};
